import React, { useEffect } from "react";
import t from "./t";
import { alertsActions } from "inbooma-api";

type Alert = {
  message?: string;
  type?: string;
  closable?: boolean;
  duration?: number;
  icon?: string;
  onClose?: () => boolean;
  _id?: string;
};
const alertSchema: Alert = {
  message: "",
  closable: false,
  duration: 4000, // Time to keep open (in ms)
  type: "default",
  icon: "",
  onClose: (): boolean => false, // onCloseNotification event hook
};

// @todo UseDispatcher instead of passing dispatcher around
type Props = {
  alert: Alert;
  dispatch: Function;
  alerts?: Alert[];
};
const NotificationItem: (props: Props) => React.JSX.Element = (props: Props): React.JSX.Element => {
  const alert = { ...alertSchema, ...props.alert };

  const closeNotification: (id: any) => void = (id: any): void => {
    props.dispatch(
      alertsActions.removeAlertById({
        id,
      }),
    );
  };

  useEffect((): void => {
    setTimeout((): void => {
      closeNotification(alert._id);
    }, alert.duration);
  });

  return (
    <div className="inb-notification">
      <div className="inb-notification--icon">
        {alert.icon === "" ? (
          <img src="/assets/img/inbooma_rocket.png" alt={""} />
        ) : (
          <i className="fi fi-check"></i>
        )}
      </div>

      <div className="inb-notification--message active">
        <p>{alert.message}</p>
      </div>

      <a
        href="#"
        className="inb-notification--close"
        onClick={() => closeNotification(alert._id)}
        title={t("close_notification")}
      >
        <i className="fi fi-x"></i>
      </a>
    </div>
  );
};

export default (props: Props): React.JSX.Element => {
  return (
    <aside id="inb-notifications">
      {typeof props.alerts !== "undefined" &&
        props.alerts.map(
          (alert: Alert): React.JSX.Element => (
            <NotificationItem key={alert._id} alert={alert} dispatch={props.dispatch} />
          ),
        )}
    </aside>
  );
};
